import { render, staticRenderFns } from "./SpacesIframe.vue?vue&type=template&id=56d5afcd&scoped=true&"
import script from "./SpacesIframe.vue?vue&type=script&lang=js&"
export * from "./SpacesIframe.vue?vue&type=script&lang=js&"
import style0 from "./SpacesIframe.vue?vue&type=style&index=0&id=56d5afcd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56d5afcd",
  null
  
)

export default component.exports